import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingCart } from 'lucide-react';
interface StickyBuyBarProps {
  onScrollToPurchase: () => void;
}
export function StickyBuyBar({
  onScrollToPurchase
}: StickyBuyBarProps) {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past 600px
      setIsVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-301">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-white border-t-2 border-[#4a7c2c] shadow-[0_-4px_20px_rgba(0,0,0,0.15)] px-4 py-3" data-id="element-302">
          <div className="flex items-center gap-3" data-id="element-303">
            <div className="flex-1" data-id="element-304">
              <p className="text-xs text-[#666666] font-medium" data-id="element-305">
                Guía de Esquejes
              </p>
              <p className="text-lg font-bold text-[#2d5016]" data-id="element-306">
                Desde $19.990{' '}
                <span className="text-xs text-[#999] line-through font-normal" data-id="element-307">
                  $34.990
                </span>
              </p>
            </div>
            <motion.button whileTap={{
          scale: 0.95
        }} onClick={onScrollToPurchase} className="bg-[#4a7c2c] text-white font-bold py-3 px-6 rounded-full shadow-lg flex items-center gap-2 text-sm whitespace-nowrap" data-id="element-308">
              <ShoppingCart className="w-4 h-4" data-id="element-309" />
              Comprar ahora
            </motion.button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}